//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Note from './Note'
import Download from './Download'
import ThemePicker from './ThemePicker/index'
export default {
  name: '',
  components: {
    Note,
    Download,
    ThemePicker
  },
  data () {
    return {
      show: false,
      currentTabComponent: 'ThemePicker'
    }
  },
  methods: {
    open (component) {
      this.show = true
      this.currentTabComponent = component
    },
    closeLayer () {
      this.show = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/layout/components/RightLayer/index.vue